import { useMutation } from "@tanstack/react-query";

import { createServiceResponseSchema, publicApi } from "@/api/axios";
import { verifyEmailResponseSchema } from "@/domains/profile/models/schemas";

export const useVerifyEmail = () => {
  return useMutation({
    mutationFn: verifyEmail,
  });
};

const verifyEmail = async ({ email }: { email: string }) => {
  const response = await publicApi.get("/profilings/email-verification", {
    params: {
      email,
    },
  });

  return createServiceResponseSchema(verifyEmailResponseSchema).parse(response.data).data;
};
